var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../../../api/axios";
import { LogLevel } from "../../../../../Shared/hooks/useLogging/Logging-types";
import { PaymentProcessor } from "../../types/PaymentProcessorTypes";
export const initPaymentMethodUpdate = (setLoading, setToken, setPublicKey, setClientSecret, setPaymentProfileId, setPaymentProcessor, datadogLog) => (paymentMethodId) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    return yield axiosPrivate
        .post(`/InitPaymentMethodUpdate`, { paymentMethodId: paymentMethodId })
        .then(({ data }) => {
        var _a, _b;
        if (!data.success) {
            datadogLog((_a = data.responseMsg) !== null && _a !== void 0 ? _a : "Unable to init payment method update", LogLevel.ERROR);
            setLoading(false);
            return {
                success: false,
                message: (_b = data.responseMsg) !== null && _b !== void 0 ? _b : "Unable to init update. Try again",
            };
        }
        if (data.clientSecret) {
            setClientSecret(data.clientSecret);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        if (data.hostedFormToken) {
            setToken(data.hostedFormToken);
            setPaymentProcessor(PaymentProcessor.AUTHORIZE);
        }
        if (data.publicKey) {
            setPublicKey(data.publicKey);
            setPaymentProcessor(PaymentProcessor.TAP);
        }
        if (data.paymentProfileId) {
            setPaymentProfileId(data.paymentProfileId);
            setPaymentProcessor(PaymentProcessor.AUTHORIZE);
        }
        setLoading(false);
        return {
            success: true,
        };
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to initialize payment method update.";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setLoading(false);
        return {
            success: false,
            message: "Failed to initialize payment method update.",
        };
    });
});
export const updatePaymentMethod = (customerCreditCardState, setLoading, setError, datadogLog) => (body) => __awaiter(void 0, void 0, void 0, function* () {
    const [customerCreditCards, setCustomerCreditCards] = customerCreditCardState;
    setLoading(true);
    const res = yield axiosPrivate
        .post("/UpdatePaymentMethod", body)
        .then(({ data }) => {
        var _a;
        if (data.success && !!(customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.length)) {
            const updatedCards = [...customerCreditCards].map((card) => {
                if (card.id === data.card.id) {
                    card = data.card;
                }
                return card;
            });
            setCustomerCreditCards(updatedCards);
        }
        if (!data.success) {
            datadogLog((_a = data.message) !== null && _a !== void 0 ? _a : "Failed to update payment profile", LogLevel.ERROR);
        }
        return data;
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to update payment profile.";
        datadogLog(errorMessage, LogLevel.ERROR, undefined, err);
        setError("Failed to update payment profile.");
        return { success: false, message: "Failed to update payment profile." };
    });
    setLoading(false);
    return res;
});
export const updatePrimaryPaymentMethod = (customerCreditCardState, setLoading, setError, datadogLog) => (paymentMethodId) => __awaiter(void 0, void 0, void 0, function* () {
    const [customerCreditCards, setCustomerCreditCards] = customerCreditCardState;
    const res = yield axiosPrivate
        .post("/UpdatePrimaryPaymentMethod", { paymentMethodId })
        .then(({ data }) => {
        var _a;
        if (data.success && !!(customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.length)) {
            const updatedCards = [...customerCreditCards].map((oc) => {
                if (oc.id === data.card.id) {
                    return Object.assign(Object.assign({}, oc), { isPrimary: true });
                }
                return Object.assign(Object.assign({}, oc), { isPrimary: false });
            });
            setCustomerCreditCards(updatedCards);
        }
        else if (!data.success) {
            datadogLog((_a = data.message) !== null && _a !== void 0 ? _a : "Failed to update primary payment method", LogLevel.ERROR);
            throw new Error(data.message);
        }
        return data;
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to update primary payment method.";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setError(err);
        return { success: false, message: "Failed to update primary payment method." };
    });
    setLoading(false);
    return res;
});
export const deactivatePaymentMethod = (customerCreditCardState, setLoading, setError, datadogLog) => (paymentMethodId) => __awaiter(void 0, void 0, void 0, function* () {
    const [customerCreditCards, setCustomerCreditCards] = customerCreditCardState;
    const res = yield axiosPrivate
        .post("/DeactivatePaymentMethod", { paymentMethodId })
        .then(({ data }) => {
        var _a;
        if (data.success && data.cardId && !!(customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.length)) {
            const otherCards = customerCreditCards.filter((card) => card.id !== data.cardId);
            setCustomerCreditCards([...otherCards]);
        }
        else if (!data.success) {
            datadogLog((_a = data.message) !== null && _a !== void 0 ? _a : "Failed to deactivate payment method", LogLevel.ERROR);
            throw new Error(data.message);
        }
        return data;
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to deactivate payment method";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setError(err);
        return { success: false, message: "Failed to deactivate payment method" };
    });
    setLoading(false);
    return res;
});
